import { createAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from '../../config/api';
import { getToken } from '../../config/cookie';

const initial = {
  isGetContentLoading: false,
  isGetContentSuccess: false,
  isGetContentFailed: false,
  contentByCategories: null,
  contentByCategoriesErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isGetContentTagsLoading: false,
  isGetContentTagsSuccess: false,
  isGetContentTagsFailed: false,
  contentTagList: null,
  contentTagListErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isSectionWiseContentLoading: false,
  isSectionWiseContentSuccess: false,
  isSectionWiseContentFailed: false,
  sectionWiseContentList: null,
  sectionWiseContentListErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isAutoPlayStatusLoading: false,
  isAutoPlayStatusSuccess: false,
  isAutoPlayStatusFailed: false,
  autoPlayStatusData: null,
  autoPlayStatusDataErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isSaveToWatchLaterLoading: false,
  isSaveToWatchLaterSuccess: false,
  isSaveToWatchLaterFailed: false,
  saveToWatchLaterResponse: null,
  saveToWatchLaterErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isUpdateLikeDislikeLoading: false,
  isUpdateLikeDislikeSuccess: false,
  isUpdateLikeDislikeFailed: false,
  updateLikeDislikeResponse: null,
  updateLikeDislikeErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isDownloadContentLoading: false,
  isDownloadContentSuccess: false,
  isDownloadContentFailed: false,
  downloadContentResponse: null,
  downloadContentErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isShareDetailsLoading: false,
  isShareDetailsSuccess: false,
  isShareDetailsFailed: false,
  shareDetailsResponse: null,
  shareDetailsErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isAddHistoryLoading: false,
  isAddHistorySuccess: false,
  isAddHistoryFailed: false,
  addHistoryResponse: null,
  addHistoryErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isGetHistoryListLoading: false,
  isGetHistoryListSuccess: false,
  isGetHistoryListFailed: false,
  historyList: {
    totalCount: 0,
    contentList: []
  },
  getHistoryListErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isGetHistoryListAllLoading: false,
  isGetHistoryListAllSuccess: false,
  isGetHistoryListAllFailed: false,
  historyListAll: {
    totalCount: 0,
    contentList: []
  },
  getHistoryListAllErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isDeleteHistoryLoading: false,
  isDeleteHistorySuccess: false,
  isDeleteHistoryFailed: false,
  deleteHistoryErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isGamificationLoading: false,
  isGamificationSuccess: false,
  isGamificationFailed: false,
  gamificationData: null,
  gamificationDataErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isReportContentLoading: false,
  isReportContentSuccess: false,
  isReportContentFailed: false,
  reportContentResponse: '',
  reportContentDataErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isCommentDataLoading: false,
  isCommentDataSuccess: false,
  isCommentDataFailed: false,
  commentsData: null,
  commentsDataErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isGetFavouriteListLoading: false,
  isGetFavouriteListSuccess: false,
  isGetFavouriteListFailed: false,
  favouriteList: {
    totalCount: 0,
    contentList: []
  },
  getFavouriteListErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isGetFavouriteListAllLoading: false,
  isGetFavouriteListAllSuccess: false,
  isGetFavouriteListAllFailed: false,
  favouriteListAll: {
    totalCount: 0,
    contentList: []
  },
  getFavouriteListAllErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isGetLibraryListLoading: false,
  isGetLibraryListSuccess: false,
  isGetLibraryListFailed: false,
  libraryList: {
    totalCount: 0,
    contentList: []
  },
  getLibraryListErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isGetLibraryListAllLoading: false,
  isGetLibraryListAllSuccess: false,
  isGetLibraryListAllFailed: false,
  libraryListAll: {
    totalCount: 0,
    contentList: []
  },
  getLibraryListAllErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isAddCommentsLoading: false,
  isAddCommentsSuccess: false,
  isAddCommentsFailed: false,
  addCommentsResponse: null,
  addCommentsErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isDeleteGamificationLoading: false,
  isDeleteGamificationSuccess: false,
  isDeleteGamificationFailed: false,
  deleteGamificationData: null,
  deleteGamificationDataErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isSaveLikeContentLoading: false,
  isSaveLikeContentSuccess: false,
  isSaveLikeContentFailed: false,
  saveLikeContentResponse: null,
  saveLikeContentResponseErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isDeleteLikeContentLoading: false,
  isDeleteLikeContentSuccess: false,
  isDeleteLikeContentFailed: false,
  deleteLikeContentResponse: null,
  deleteLikeContentResponseErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  }
};

export const revertFlowsFormData = createAction('REVERT_FLOWS_FORM_DATA');

const buildLegacyCategoriesUrl = queryParam =>
  `content/getContentByCategories?searchCriteria=${queryParam.search || ''}&themeId=${queryParam?.themeId || ''}&mediumId=${queryParam?.mediumId || ''}&unitId=${queryParam?.unitId || ''}&grade=${queryParam.grade || ''}&userId=${queryParam.userId || ''}&tags=${queryParam?.tags || ''}&loggedInUserName=${queryParam?.loggedInUserName || ''}&contentType=${encodeURIComponent(queryParam?.contentType || '')}`;

const buildEnhancedSearchUrl = queryParam =>
  `content/search/enhanced?loggedInUserName=${queryParam?.loggedInUserName || ''}&grade=${queryParam.grade || ''}&themeId=${queryParam?.themeId || ''}&mediumId=${queryParam?.mediumId || ''}&unitId=${queryParam?.unitId || ''}&tags=${queryParam?.tags || ''}&searchCriteria=${queryParam.search || ''}&userId=${queryParam.userId || ''}&contentType=${encodeURIComponent(queryParam?.contentType || '')}`;

const isFlashcardItem = item => {
  const uploadType = (item?.upload_type || item?.uploadType || '')
    .replace(/\s+/g, '')
    .toLowerCase();
  const contentType = (item?.contentType || item?.content_type || '')
    .replace(/\s+/g, '')
    .toLowerCase();

  return (
    uploadType.includes('flashcard') ||
    contentType.includes('flashcard') ||
    Boolean(item?.flashCard?.length) ||
    Boolean(item?.flashcard?.length)
  );
};

const incrementSectionCounts = (section, item) => {
  if (isFlashcardItem(item)) {
    section.flashcardCount += 1;
    return;
  }

  const contentType = (
    item?.contentType ||
    item?.content_type ||
    ''
  ).toLowerCase();

  if (contentType === 'video') {
    section.videoCount += 1;
  } else if (['document', 'pdf', 'doc'].includes(contentType)) {
    section.documentCount += 1;
  } else if (contentType === 'audio') {
    section.audioCount += 1;
  }
};

const recalculateSectionCounts = section => {
  section.videoCount = 0;
  section.documentCount = 0;
  section.audioCount = 0;
  section.flashcardCount = 0;

  (section.contents || []).forEach(item =>
    incrementSectionCounts(section, item)
  );
};

const normalizeFlashcardFields = item => ({
  ...item,
  upload_type: item?.upload_type || item?.uploadType || 'Flashcard',
  uploadType: item?.uploadType || item?.upload_type || 'Flashcard'
});

const normalizeContentListItem = item => {
  if (!item || typeof item !== 'object') {
    return item;
  }

  const uploadType = item.upload_type || item.uploadType || '';
  const thumbnailFileUrl =
    item.thumbnail_file_url ||
    item.thumbnailFileUrl ||
    item.thumbnailUrl ||
    item.thumbnail_url ||
    '';
  const contentFileUrl = item.content_file_url || item.contentFileUrl || '';

  return {
    ...item,
    upload_type: uploadType,
    uploadType: item.uploadType || uploadType,
    thumbnail_file_url: thumbnailFileUrl,
    thumbnailFileUrl,
    content_file_url: contentFileUrl,
    contentFileUrl,
    encrypted_content_id:
      item.encrypted_content_id || item.encryptedContentId || '',
    encryptedContentId:
      item.encryptedContentId || item.encrypted_content_id || '',
    content_id: item.content_id ?? item.contentId,
    contentId: item.contentId ?? item.content_id,
    updated_dt:
      item.updated_dt || item.updatedDt || item.updatedDate || item.updatedOn
  };
};

const dedupeContentItems = items => {
  const seen = new Set();

  return items.filter(item => {
    const id = item?.content_id || item?.contentId || item?.id;

    if (!id) {
      return true;
    }

    if (seen.has(id)) {
      return false;
    }

    seen.add(id);
    return true;
  });
};

const extractFlashcardsIntoSection = sections => {
  if (!Array.isArray(sections) || sections.length === 0) {
    return sections;
  }

  const flashcardItems = [];
  let flashcardSectionId = null;
  const cleanedSections = [];

  sections.forEach(section => {
    const sectionName = (section?.sectionName || '').toLowerCase();

    if (sectionName.includes('flashcard')) {
      (section.contents || []).forEach(item => {
        flashcardItems.push(
          normalizeContentListItem(normalizeFlashcardFields(item))
        );

        if (!flashcardSectionId) {
          flashcardSectionId = section.sectionId || item.sectionId || null;
        }
      });
      return;
    }

    const nonFlashcardContents = [];

    (section.contents || []).forEach(item => {
      if (isFlashcardItem(item)) {
        flashcardItems.push(
          normalizeContentListItem(normalizeFlashcardFields(item))
        );

        if (!flashcardSectionId) {
          flashcardSectionId = item.sectionId || section.sectionId || null;
        }
      } else {
        nonFlashcardContents.push(normalizeContentListItem(item));
      }
    });

    if (nonFlashcardContents.length > 0) {
      const nextSection = {
        ...section,
        contents: nonFlashcardContents
      };
      recalculateSectionCounts(nextSection);
      cleanedSections.push(nextSection);
    }
  });

  const uniqueFlashcards = dedupeContentItems(flashcardItems);

  if (uniqueFlashcards.length === 0) {
    return cleanedSections.length > 0 ? cleanedSections : sections;
  }

  return [
    ...cleanedSections,
    {
      sectionName: 'Flashcards',
      sectionId: flashcardSectionId,
      contents: uniqueFlashcards,
      videoCount: 0,
      documentCount: 0,
      audioCount: 0,
      flashcardCount: uniqueFlashcards.length
    }
  ];
};

const groupContentIntoSections = contentItems => {
  const sectionsMap = {};

  contentItems.forEach(item => {
    const sectionName = isFlashcardItem(item)
      ? 'Flashcards'
      : item.section || item.sectionName || 'Uncategorized';

    if (!sectionsMap[sectionName]) {
      sectionsMap[sectionName] = {
        sectionName,
        sectionId: isFlashcardItem(item)
          ? item.sectionId || null
          : item.sectionId || null,
        contents: [],
        videoCount: 0,
        documentCount: 0,
        audioCount: 0,
        flashcardCount: 0
      };
    }

    const normalizedItem = normalizeContentListItem(
      isFlashcardItem(item) ? normalizeFlashcardFields(item) : item
    );

    sectionsMap[sectionName].contents.push(normalizedItem);
    incrementSectionCounts(sectionsMap[sectionName], normalizedItem);

    if (isFlashcardItem(item) && !sectionsMap[sectionName].sectionId) {
      sectionsMap[sectionName].sectionId = item.sectionId || null;
    }
  });

  return Object.values(sectionsMap);
};

const isSectionGroupedList = dataList =>
  Array.isArray(dataList) &&
  dataList.length > 0 &&
  (Array.isArray(dataList[0]?.contents) || dataList[0]?.sectionName);

const transformEnhancedResponse = data => {
  const dataList = data?.payload?.dataList;

  if (!Array.isArray(dataList) || dataList.length === 0) {
    return data;
  }

  const sections = isSectionGroupedList(dataList)
    ? extractFlashcardsIntoSection(
        dataList.map(section => ({
          ...section,
          contents: [...(section.contents || [])]
        }))
      )
    : extractFlashcardsIntoSection(groupContentIntoSections(dataList));

  return {
    ...data,
    payload: {
      ...data.payload,
      dataList: sections
    }
  };
};

const transformLegacyResponse = data => {
  const dataList = data?.payload?.dataList;

  if (!Array.isArray(dataList) || dataList.length === 0) {
    return data;
  }

  return {
    ...data,
    payload: {
      ...data.payload,
      dataList: extractFlashcardsIntoSection(
        dataList.map(section => ({
          ...section,
          contents: [...(section.contents || [])]
        }))
      )
    }
  };
};

export const getContentByCategories = createAsyncThunk(
  'flows/updateFormSequence',
  async ({ payload, queryParam }, { rejectWithValue }) => {
    const fetchLegacyCategories = async () => {
      const response = await api.post(
        buildLegacyCategoriesUrl(queryParam),
        payload
      );
      return transformLegacyResponse(response.data);
    };

    const fetchEnhancedCategories = async () => {
      const response = await api.post(
        buildEnhancedSearchUrl(queryParam),
        payload
      );
      return transformEnhancedResponse(response.data);
    };

    try {
      const enhancedData = await fetchEnhancedCategories();
      const enhancedList = enhancedData?.payload?.dataList ?? [];

      if (enhancedList.length > 0) {
        return enhancedData;
      }

      return await fetchLegacyCategories();
    } catch (enhancedError) {
      try {
        return await fetchLegacyCategories();
      } catch (legacyError) {
        return rejectWithValue(
          legacyError.response?.data?.error ||
            enhancedError.response?.data?.error
        );
      }
    }
  }
);

export const getContentTags = createAsyncThunk(
  'tags/getContentTags',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`tags/contentTags`);

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

const normalizeSearchResponse = data => {
  const dataList = data?.payload?.dataList;

  if (!Array.isArray(dataList)) {
    return data;
  }

  return {
    ...data,
    payload: {
      ...data.payload,
      dataList: dataList.map(normalizeContentListItem)
    }
  };
};

export const getAllContentBySection = createAsyncThunk(
  'content/getAllContentBySection',
  async ({ payload, queryParam }, { rejectWithValue }) => {
    try {
      const token = getToken();
      const buildQueryString = params => {
        const queryParts = [];

        queryParts.push(`searchCriteria=${params?.search || ''}`);
        queryParts.push(`section=${params.sectionId || ''}`);
        queryParts.push(`userId=${params.userId || ''}`);
        queryParts.push(
          `encryptedContentId=${params?.encryptedContentId || ''}`
        );

        if (
          params.grade !== undefined &&
          params.grade !== null &&
          params.grade !== ''
        ) {
          queryParts.push(`grade=${params.grade}`);
        }
        if (
          params?.tags !== undefined &&
          params?.tags !== null &&
          params?.tags !== ''
        ) {
          queryParts.push(`tags=${params.tags}`);
        }
        if (
          params?.themeId !== undefined &&
          params?.themeId !== null &&
          params?.themeId !== ''
        ) {
          queryParts.push(`themeId=${params.themeId}`);
        }
        if (
          params?.mediumId !== undefined &&
          params?.mediumId !== null &&
          params?.mediumId !== ''
        ) {
          queryParts.push(`mediumId=${params.mediumId}`);
        }
        if (
          params?.unitId !== undefined &&
          params?.unitId !== null &&
          params?.unitId !== ''
        ) {
          queryParts.push(`unitId=${params.unitId}`);
        }
        if (
          params?.contentType !== undefined &&
          params?.contentType !== null &&
          params?.contentType !== ''
        ) {
          queryParts.push(
            `contentType=${encodeURIComponent(params.contentType)}`
          );
        }
        if (
          params?.autoPlayFlag !== undefined &&
          params?.autoPlayFlag !== null
        ) {
          queryParts.push(`autoPlayFlag=${params.autoPlayFlag}`);
        }

        return queryParts.join('&');
      };

      const queryString = buildQueryString(queryParam);

      if (token) {
        const response = await api.post(
          `content/search?${queryString}`,
          payload
        );
        return normalizeSearchResponse(response.data);
      }

      const response = await api.post(
        `openContent/search?${queryString}`,
        payload
      );
      return normalizeSearchResponse(response.data);
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const updateAutoPlayStatus = createAsyncThunk(
  'content/updateAutoPlayStatus',
  async ({ payload }, { rejectWithValue }) => {
    try {
      const response = await api.post(`resources/autoPlay`, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const addSaveToWatchLater = createAsyncThunk(
  'content/addSaveToWatchLater',
  async ({ payload, isRemove }, { rejectWithValue }) => {
    try {
      if (isRemove) {
        const response = await api.put(
          `resources/deleteUserLibraryContent/${payload.contentId}?userId=${payload.userId}&loggedInUserName=${payload.loggedInUserName}`
        );

        return response.data;
      } else {
        const response = await api.post(`resources/addLibrary`, payload);
        return response.data;
      }
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const updateLikeDislike = createAsyncThunk(
  'content/updateLikeDislike',
  async ({ payload, contentLike }, { rejectWithValue }) => {
    try {
      if (contentLike === 'No') {
        const response = await api.post(`favourite`, payload);
        return response.data;
      } else {
        const response = await api.put(
          `favourite/deleteFavouriteContent/${payload?.contentId}?userId=${payload?.userId}&loggedInUserName=${payload?.loggedInUserName}`
        );
        return response.data;
      }
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const downloadContent = createAsyncThunk(
  'content/downloadContent',
  async ({ payload }, { rejectWithValue }) => {
    try {
      const response = await api.post(`resources/addDownloads`, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const shareDetails = createAsyncThunk(
  'content/shareDetails',
  async ({ payload }, { rejectWithValue }) => {
    try {
      const response = await api.post(`resources/addShareDetails`, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const addHistory = createAsyncThunk(
  'content/addHistory',
  async ({ payload }, { rejectWithValue }) => {
    try {
      const response = await api.post(`resources/addHistory`, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const addContentViews = createAsyncThunk(
  'content/addContentViews',
  async ({ payload }, { rejectWithValue }) => {
    try {
      const response = await api.post(`resources/addContentViews`, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getHistoryList = createAsyncThunk(
  'content/getHistoryList',
  async ({ payload, search }, { rejectWithValue }) => {
    try {
      let response;
      if (search == '' || search == null) {
        response = await api.post(`resources/getHistoryContentByDate`, payload);
      } else {
        response = await api.post(
          `resources/getHistoryContentByDate?searchCriteria=${search}`,
          payload
        );
      }
      return response.data?.payload || initial.usersData;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getHistoryListAll = createAsyncThunk(
  'content/getHistoryListAll',
  async ({ payload, search }, { rejectWithValue }) => {
    try {
      let response;
      if (search == '' || search == null) {
        response = await api.post(`resources/getHistoryContent`, payload);
      } else {
        response = await api.post(
          `resources/getHistoryContent?searchCriteria=${search}`,
          payload
        );
      }
      return response.data?.payload || initial.usersData;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getFavouriteList = createAsyncThunk(
  'content/getFavouriteList',
  async ({ payload, search }, { rejectWithValue }) => {
    try {
      let response;
      if (search == '' || search == null) {
        response = await api.post(
          `resources/getFavouriteContentByDate`,
          payload
        );
      } else {
        response = await api.post(
          `resources/getFavouriteContentByDate?searchCriteria=${search}`,
          payload
        );
      }
      return response.data?.payload || initial.usersData;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getFavouriteListAll = createAsyncThunk(
  'content/getFavouriteListAll',
  async ({ payload, search }, { rejectWithValue }) => {
    try {
      let response;
      if (search == '' || search == null) {
        response = await api.post(`resources/getFavouriteContent`, payload);
      } else {
        response = await api.post(
          `resources/getFavouriteContent?searchCriteria=${search}`,
          payload
        );
      }
      return response.data?.payload || initial.usersData;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getLibraryList = createAsyncThunk(
  'content/getLibraryList',
  async ({ payload, search }, { rejectWithValue }) => {
    try {
      let response;
      if (search == '' || search == null) {
        response = await api.post(
          `resources/getLibraryContentByCategories`,
          payload
        );
      } else {
        response = await api.post(
          `resources/getLibraryContentByCategories?searchCriteria=${search}`,
          payload
        );
      }
      return response.data?.payload || initial.usersData;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getLibraryListAll = createAsyncThunk(
  'content/getLibraryListAll',
  async ({ payload, search }, { rejectWithValue }) => {
    try {
      let response;
      if (search == '' || search == null) {
        response = await api.post(`resources/getLibraryContent`, payload);
      } else {
        response = await api.post(
          `resources/getLibraryContent?searchCriteria=${search}`,
          payload
        );
      }
      return response.data?.payload || initial.usersData;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getComments = createAsyncThunk(
  'content/getComments',
  async ({ payload, contentId }, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `resources/getCommentsData?contentId=${contentId}`,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const gamification = createAsyncThunk(
  'content/gamification',
  async ({ gamificationPayload }, { rejectWithValue }) => {
    try {
      const response = await api.post(`gamification`, gamificationPayload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const deleteGamification = createAsyncThunk(
  'content/deleteGamification',
  async ({ payload }, { rejectWithValue }) => {
    try {
      const response = await api.put(
        `gamification/deleteGamificationPoints/${payload.contentId}?userId=${payload.userId}&loggedInUserName=${payload.loggedInUserName}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const reportContent = createAsyncThunk(
  'content/reportContent',
  async ({ payload }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/content/reportContent`, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const addComments = createAsyncThunk(
  'content/addComments',
  async ({ payload }, { rejectWithValue }) => {
    try {
      const response = await api.put(`resources/addComment`, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const deleteAllHistory = createAsyncThunk(
  'content/deleteAllHistory',
  async ({ userId }, { rejectWithValue }) => {
    try {
      const response = await api.put(
        `resources/deleteUserHistoryContent?userId=${userId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const saveLikeContent = createAsyncThunk(
  'content/saveLikeContent',
  async ({ payload }, { rejectWithValue }) => {
    try {
      const response = await api.post(`content/saveContentLike`, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteLikeContent = createAsyncThunk(
  'content/deleteLikeContent',
  async ({ payload }, { rejectWithValue }) => {
    try {
      const response = await api.put(
        `content/deleteLikedContent/${payload.contentId || 0}?userId=${payload.userId || 0}&loggedInUserName=${payload.loggedInUserName || ''}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const revertResources = createAction('REVERT_RESOURCES');

export const resourceSlice = createSlice({
  name: 'resource',
  initialState: initial,
  extraReducers: builder => {
    builder

      .addCase(revertResources, state => {
        state.isSaveToWatchLaterLoading = false;
        state.isSaveToWatchLaterSuccess = false;
        state.isSaveToWatchLaterFailed = false;
        state.saveToWatchLaterResponse = null;
        state.saveToWatchLaterErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
        state.isUpdateLikeDislikeLoading = false;
        state.isUpdateLikeDislikeSuccess = false;
        state.isUpdateLikeDislikeFailed = false;
        state.updateLikeDislikeResponse = null;
        state.updateLikeDislikeErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
        state.isShareDetailsLoading = false;
        state.isShareDetailsSuccess = false;
        state.isShareDetailsFailed = false;
        state.shareDetailsResponse = null;
        state.shareDetailsErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };

        state.isSectionWiseContentLoading = false;
        state.isSectionWiseContentSuccess = false;
        state.isSectionWiseContentFailed = false;
        state.sectionWiseContentList = null;
        state.sectionWiseContentListErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };

        state.isAddCommentsLoading = false;
        state.isAddCommentsSuccess = false;
        state.isAddCommentsFailed = false;
        state.addCommentsResponse = null;
        state.addCommentsErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
        state.isGetHistoryListLoading = false;
        state.isGetHistoryListSuccess = false;
        state.isGetHistoryListFailed = false;
        // state.historyList = null;
        state.getHistoryListErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };

        state.isGetHistoryListAllLoading = false;
        state.isGetHistoryListAllSuccess = false;
        state.isGetHistoryListAllFailed = false;
        // state.historyListAll = null;
        state.getHistoryListAllErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };

        state.isGetFavouriteListLoading = false;
        state.isGetFavouriteListSuccess = false;
        state.isGetFavouriteListFailed = false;
        // state.favouriteList = null;
        state.getFavouriteListErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };

        state.isGetFavouriteListAllLoading = false;
        state.isGetFavouriteListAllSuccess = false;
        state.isGetFavouriteListAllFailed = false;
        // state.favouriteListAll = null;
        state.getFavouriteListAllErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };

        state.isGetLibraryListLoading = false;
        state.isGetLibraryListSuccess = false;
        state.isGetLibraryListFailed = false;
        // state.libraryList = null;
        state.getLibraryListErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };

        state.isGetLibraryListAllLoading = false;
        state.isGetLibraryListAllSuccess = false;
        state.isGetLibraryListAllFailed = false;
        // state.libraryListAll = null;
        state.getLibraryListAllErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };

        state.isDeleteHistoryLoading = false;
        state.isDeleteHistorySuccess = false;
        state.isDeleteHistoryFailed = false;
        state.deleteHistoryErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };

        state.isReportContentLoading = false;
        state.isReportContentSuccess = false;
        state.isReportContentFailed = false;
        state.reportContentResponse = '';
        state.reportContentDataErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
      })

      .addCase(getContentByCategories.pending, state => {
        state.isGetContentLoading = true;
        state.isGetContentSuccess = false;
        state.isGetContentFailed = false;
        state.contentByCategories = [];
        state.contentByCategoriesErrorContainer =
          initial.contentByCategoriesErrorContainer;
      })
      .addCase(getContentByCategories.fulfilled, (state, action) => {
        state.isGetContentLoading = false;
        state.isGetContentSuccess = true;
        state.isGetContentFailed = false;
        state.contentByCategories = action.payload;
      })

      .addCase(getContentByCategories.rejected, (state, action) => {
        state.isGetContentLoading = false;
        state.isGetContentSuccess = false;
        state.isGetContentFailed = true;
        state.contentByCategories = null;
        state.contentByCategoriesErrorContainer = {
          ...state.contentByCategoriesErrorContainer,
          ...action.payload
        };
      })

      .addCase(getContentTags.pending, state => {
        state.isGetContentTagsLoading = true;
        state.isGetContentTagsSuccess = false;
        state.isGetContentTagsFailed = false;
        state.contentTagList = [];
        state.contentTagListErrorContainer =
          initial.contentTagListErrorContainer;
      })
      .addCase(getContentTags.fulfilled, (state, action) => {
        state.isGetContentTagsLoading = false;
        state.isGetContentTagsSuccess = true;
        state.isGetContentTagsFailed = false;
        state.contentTagList = action.payload;
      })

      .addCase(getContentTags.rejected, (state, action) => {
        state.isGetContentTagsLoading = false;
        state.isGetContentTagsSuccess = false;
        state.isGetContentTagsFailed = true;
        state.contentTagList = null;
        state.contentTagListErrorContainer = {
          ...state.contentTagListErrorContainer,
          ...action.payload
        };
      })
      .addCase(getAllContentBySection.pending, state => {
        state.isSectionWiseContentLoading = true;
        state.isSectionWiseContentSuccess = false;
        state.isSectionWiseContentFailed = false;
        state.sectionWiseContentList = [];
        state.sectionWiseContentListErrorContainer =
          initial.sectionWiseContentListErrorContainer;
      })
      .addCase(getAllContentBySection.fulfilled, (state, action) => {
        state.isSectionWiseContentLoading = false;
        state.isSectionWiseContentSuccess = true;
        state.isSectionWiseContentFailed = false;
        state.sectionWiseContentList = action.payload;
      })

      .addCase(getAllContentBySection.rejected, (state, action) => {
        state.isSectionWiseContentLoading = false;
        state.isSectionWiseContentSuccess = false;
        state.isSectionWiseContentFailed = true;
        state.sectionWiseContentList = null;
        state.sectionWiseContentListErrorContainer = {
          ...state.sectionWiseContentListErrorContainer,
          ...action.payload
        };
      })

      .addCase(updateAutoPlayStatus.pending, state => {
        state.isAutoPlayStatusLoading = true;
        state.isAutoPlayStatusSuccess = false;
        state.isAutoPlayStatusFailed = false;
        state.autoPlayStatusData = [];
        state.autoPlayStatusDataErrorContainer =
          initial.autoPlayStatusDataErrorContainer;
      })
      .addCase(updateAutoPlayStatus.fulfilled, (state, action) => {
        state.isAutoPlayStatusLoading = false;
        state.isAutoPlayStatusSuccess = true;
        state.isAutoPlayStatusFailed = false;
        state.autoPlayStatusData = action.payload;
      })

      .addCase(updateAutoPlayStatus.rejected, (state, action) => {
        state.isAutoPlayStatusLoading = false;
        state.isAutoPlayStatusSuccess = false;
        state.isAutoPlayStatusFailed = true;
        state.autoPlayStatusData = null;
        state.autoPlayStatusDataErrorContainer = {
          ...state.autoPlayStatusDataErrorContainer,
          ...action.payload
        };
      })

      .addCase(addSaveToWatchLater.pending, state => {
        state.isSaveToWatchLaterLoading = true;
        state.isSaveToWatchLaterSuccess = false;
        state.isSaveToWatchLaterFailed = false;
        state.saveToWatchLaterResponse = null;
        state.saveToWatchLaterErrorContainer =
          initial.saveToWatchLaterErrorContainer;
      })
      .addCase(addSaveToWatchLater.fulfilled, (state, action) => {
        state.isSaveToWatchLaterLoading = false;
        state.isSaveToWatchLaterSuccess = true;
        state.isSaveToWatchLaterFailed = false;
        state.saveToWatchLaterResponse = action.payload;
      })

      .addCase(addSaveToWatchLater.rejected, (state, action) => {
        state.isSaveToWatchLaterLoading = false;
        state.isSaveToWatchLaterSuccess = false;
        state.isSaveToWatchLaterFailed = true;
        state.saveToWatchLaterResponse = null;
        state.saveToWatchLaterErrorContainer = {
          ...state.saveToWatchLaterErrorContainer,
          ...action.payload
        };
      })

      .addCase(updateLikeDislike.pending, state => {
        state.isUpdateLikeDislikeLoading = true;
        state.isUpdateLikeDislikeSuccess = false;
        state.isUpdateLikeDislikeFailed = false;
        state.updateLikeDislikeResponse = null;
        state.updateLikeDislikeErrorContainer =
          initial.updateLikeDislikeErrorContainer;
      })
      .addCase(updateLikeDislike.fulfilled, (state, action) => {
        state.isUpdateLikeDislikeLoading = false;
        state.isUpdateLikeDislikeSuccess = true;
        state.isUpdateLikeDislikeFailed = false;
        state.updateLikeDislikeResponse = action.payload;
      })

      .addCase(updateLikeDislike.rejected, (state, action) => {
        state.isUpdateLikeDislikeLoading = false;
        state.isUpdateLikeDislikeSuccess = false;
        state.isUpdateLikeDislikeFailed = true;
        state.updateLikeDislikeResponse = null;
        state.updateLikeDislikeErrorContainer = {
          ...state.updateLikeDislikeErrorContainer,
          ...action.payload
        };
      })

      .addCase(downloadContent.pending, state => {
        state.isDownloadContentLoading = true;
        state.isDownloadContentSuccess = false;
        state.isDownloadContentFailed = false;
        state.downloadContentResponse = null;
        state.downloadContentErrorContainer =
          initial.downloadContentErrorContainer;
      })
      .addCase(downloadContent.fulfilled, (state, action) => {
        state.isDownloadContentLoading = false;
        state.isDownloadContentSuccess = true;
        state.isDownloadContentFailed = false;
        state.downloadContentResponse = action.payload;
      })

      .addCase(downloadContent.rejected, (state, action) => {
        state.isDownloadContentLoading = false;
        state.isDownloadContentSuccess = false;
        state.isDownloadContentFailed = true;
        state.downloadContentResponse = null;
        state.downloadContentErrorContainer = {
          ...state.downloadContentErrorContainer,
          ...action.payload
        };
      })

      .addCase(shareDetails.pending, state => {
        state.isShareDetailsLoading = true;
        state.isShareDetailsSuccess = false;
        state.isShareDetailsFailed = false;
        state.shareDetailsResponse = null;
        state.shareDetailsErrorContainer = initial.shareDetailsErrorContainer;
      })
      .addCase(shareDetails.fulfilled, (state, action) => {
        state.isShareDetailsLoading = false;
        state.isShareDetailsSuccess = true;
        state.isShareDetailsFailed = false;
        state.shareDetailsResponse = action.payload;
      })

      .addCase(shareDetails.rejected, (state, action) => {
        state.isShareDetailsLoading = false;
        state.isShareDetailsSuccess = false;
        state.isShareDetailsFailed = true;
        state.shareDetailsResponse = null;
        state.shareDetailsErrorContainer = {
          ...state.shareDetailsErrorContainer,
          ...action.payload
        };
      })

      .addCase(addHistory.pending, state => {
        state.isAddHistoryLoading = true;
        state.isAddHistorySuccess = false;
        state.isAddHistoryFailed = false;
        state.addHistoryResponse = null;
        state.addHistoryErrorContainer = initial.addHistoryErrorContainer;
      })
      .addCase(addHistory.fulfilled, (state, action) => {
        state.isAddHistoryLoading = false;
        state.isAddHistorySuccess = true;
        state.isAddHistoryFailed = false;
        state.addHistoryResponse = action.payload;
      })

      .addCase(addHistory.rejected, (state, action) => {
        state.isAddHistoryLoading = false;
        state.isAddHistorySuccess = false;
        state.isAddHistoryFailed = true;
        state.addHistoryResponse = null;
        state.addHistoryErrorContainer = {
          ...state.addHistoryErrorContainer,
          ...action.payload
        };
      })

      .addCase(getHistoryList.pending, state => {
        state.isGetHistoryListLoading = true;
        state.isGetHistoryListSuccess = false;
        state.isGetHistoryListFailed = false;
        state.getHistoryListErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getHistoryList.fulfilled, (state, action) => {
        state.isGetHistoryListLoading = false;
        state.isGetHistoryListSuccess = true;
        state.historyList = {
          ...state.historyList,
          contentList: action.payload?.dataList,
          totalCount: action.payload?.totalCount
        };
      })
      .addCase(getHistoryList.rejected, (state, action) => {
        state.isGetHistoryListLoading = false;
        state.isGetHistoryListFailed = true;
        state.historyList = initial.historyList;
        state.getHistoryListErrorContainer = {
          ...state.getHistoryListErrorContainer,
          ...action.payload
        };
      })

      .addCase(getHistoryListAll.pending, state => {
        state.isGetHistoryListAllLoading = true;
        state.isGetHistoryListAllSuccess = false;
        state.isGetHistoryListAllFailed = false;
        state.getHistoryListALLErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getHistoryListAll.fulfilled, (state, action) => {
        state.isGetHistoryListAllLoading = false;
        state.isGetHistoryListAllSuccess = true;
        state.historyListAll = {
          ...state.historyListAll,
          contentList: action.payload?.dataList,
          totalCount: action.payload?.totalCount
        };
      })
      .addCase(getHistoryListAll.rejected, (state, action) => {
        state.isGetHistoryListAllLoading = false;
        state.isGetHistoryListAllFailed = true;
        state.historyList = initial.historyList;
        state.getHistoryListALLErrorContainer = {
          ...state.getHistoryListALLErrorContainer,
          ...action.payload
        };
      })

      .addCase(getFavouriteList.pending, state => {
        state.isGetFavouriteListLoading = true;
        state.isGetFavouriteListSuccess = false;
        state.isGetFavouriteListFailed = false;
        state.getFavouriteListErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getFavouriteList.fulfilled, (state, action) => {
        state.isGetFavouriteListLoading = false;
        state.isGetFavouriteListSuccess = true;
        state.favouriteList = {
          ...state.favouriteList,
          contentList: action.payload?.dataList,
          totalCount: action.payload?.totalCount
        };
      })
      .addCase(getFavouriteList.rejected, (state, action) => {
        state.isGetFavouriteListLoading = false;
        state.isGetFavouriteListFailed = true;
        state.favouriteList = initial.favouriteList;
        state.getFavouriteListErrorContainer = {
          ...state.getFavouriteListErrorContainer,
          ...action.payload
        };
      })

      .addCase(getFavouriteListAll.pending, state => {
        state.isGetFavouriteListAllLoading = true;
        state.isGetFavouriteListAllSuccess = false;
        state.isGetFavouriteListAllFailed = false;
        state.getFavouriteListAllErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getFavouriteListAll.fulfilled, (state, action) => {
        state.isGetFavouriteListAllLoading = false;
        state.isGetFavouriteListAllSuccess = true;
        state.favouriteListAll = {
          ...state.favouriteList,
          contentList: action.payload?.dataList,
          totalCount: action.payload?.totalCount
        };
      })
      .addCase(getFavouriteListAll.rejected, (state, action) => {
        state.isGetFavouriteListAllLoading = false;
        state.isGetFavouriteListAllFailed = true;
        state.favouriteListAll = initial.favouriteListAll;
        state.getFavouriteListAllErrorContainer = {
          ...state.getFavouriteListAllErrorContainer,
          ...action.payload
        };
      })

      .addCase(getLibraryList.pending, state => {
        state.isGetLibraryListLoading = true;
        state.isGetLibraryListSuccess = false;
        state.isGetLibraryListFailed = false;
        state.getLibraryListErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getLibraryList.fulfilled, (state, action) => {
        state.isGetLibraryListLoading = false;
        state.isGetLibraryListSuccess = true;
        state.libraryList = {
          ...state.libraryList,
          contentList: action.payload?.dataList,
          totalCount: action.payload?.totalCount
        };
      })
      .addCase(getLibraryList.rejected, (state, action) => {
        state.isGetLibraryListLoading = false;
        state.isGetLibraryListFailed = true;
        state.libraryList = initial.libraryList;
        state.getLibraryListErrorContainer = {
          ...state.getLibraryListErrorContainer,
          ...action.payload
        };
      })

      .addCase(getLibraryListAll.pending, state => {
        state.isGetLibraryListAllLoading = true;
        state.isGetLibraryListAllSuccess = false;
        state.isGetLibraryListAllFailed = false;
        state.getLibraryListAllErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getLibraryListAll.fulfilled, (state, action) => {
        state.isGetLibraryListAllLoading = false;
        state.isGetLibraryListAllSuccess = true;
        state.libraryListAll = {
          ...state.libraryListAll,
          contentList: action.payload?.dataList,
          totalCount: action.payload?.totalCount
        };
      })
      .addCase(getLibraryListAll.rejected, (state, action) => {
        state.isGetLibraryListAllLoading = false;
        state.isGetLibraryListAllFailed = true;
        state.libraryList = initial.libraryList;
        state.getLibraryListAllErrorContainer = {
          ...state.getLibraryListAllErrorContainer,
          ...action.payload
        };
      })

      .addCase(getComments.pending, state => {
        state.isCommentDataLoading = true;
        state.isCommentDataSuccess = false;
        state.isCommentDataFailed = false;
        state.commentsData = null;
        state.commentsDataErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getComments.fulfilled, (state, action) => {
        state.isCommentDataLoading = false;
        state.isCommentDataSuccess = true;
        state.commentsData = action.payload;
      })
      .addCase(getComments.rejected, (state, action) => {
        state.isCommentDataLoading = false;
        state.isCommentDataFailed = true;
        state.commentsData = null;
        state.commentsDataErrorContainer = {
          ...state.commentsDataErrorContainer,
          ...action.payload
        };
      })

      .addCase(gamification.pending, state => {
        state.isGamificationLoading = true;
        state.isGamificationSuccess = false;
        state.isGamificationFailed = false;
        state.gamificationData = null;
        state.gamificationDataErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(gamification.fulfilled, (state, action) => {
        state.isGamificationLoading = false;
        state.isGamificationSuccess = true;
        state.gamificationData = action.payload;
      })
      .addCase(gamification.rejected, (state, action) => {
        state.isGamificationLoading = false;
        state.isGamificationFailed = true;
        state.gamificationData = null;
        state.gamificationDataErrorContainer = {
          ...state.gamificationDataErrorContainer,
          ...action.payload
        };
      })

      .addCase(reportContent.pending, state => {
        state.isReportContentLoading = true;
        state.isReportContentSuccess = false;
        state.isReportContentFailed = false;
        state.reportContentResponse = '';
        state.reportContentDataErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(reportContent.fulfilled, (state, action) => {
        state.isReportContentLoading = false;
        state.isReportContentSuccess = true;
        state.reportContentResponse = action.payload?.payload?.message;
      })
      .addCase(reportContent.rejected, (state, action) => {
        state.isReportContentLoading = false;
        state.isReportContentFailed = true;
        state.reportContentResponse = '';
        state.reportContentDataErrorContainer = {
          ...state.reportContentDataErrorContainer,
          ...action.payload
        };
      })

      .addCase(addComments.pending, state => {
        state.isAddCommentsLoading = true;
        state.isAddCommentsSuccess = false;
        state.isAddCommentsFailed = false;
        state.addCommentsResponse = null;
        state.addCommentsErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(addComments.fulfilled, (state, action) => {
        state.isAddCommentsLoading = false;
        state.isAddCommentsSuccess = true;
        state.addCommentsResponse = action.payload;
      })
      .addCase(addComments.rejected, (state, action) => {
        state.isAddCommentsLoading = false;
        state.isAddCommentsFailed = true;
        state.addCommentsResponse = null;
        state.addCommentsErrorContainer = {
          ...state.addCommentsErrorContainer,
          ...action.payload
        };
      })

      .addCase(deleteAllHistory.pending, state => {
        state.isDeleteHistoryLoading = true;
        state.isDeleteHistorySuccess = false;
        state.isDeleteHistoryFailed = false;
        state.deleteHistoryErrorContainer = {
          error: false,
          errorMessage: 'Internal Server Error',
          description: 'Something Went Wrong',
          statusCode: 0
        };
      })
      .addCase(deleteAllHistory.fulfilled, state => {
        state.isDeleteHistoryLoading = false;
        state.isDeleteHistoryFailed = false;
        state.isDeleteHistorySuccess = true;
      })
      .addCase(deleteAllHistory.rejected, (state, action) => {
        state.isDeleteHistoryLoading = false;
        state.isDeleteHistorySuccess = false;
        state.isDeleteHistoryFailed = true;
        state.deleteHistoryErrorContainer = {
          ...state.deleteHistoryErrorContainer,
          ...action.payload
        };
      })

      .addCase(deleteGamification.pending, state => {
        state.isDeleteGamificationLoading = true;
        state.isDeleteGamificationSuccess = false;
        state.isDeleteGamificationFailed = false;
        state.deleteGamificationData = null;
        state.deleteGamificationDataErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(deleteGamification.fulfilled, (state, action) => {
        state.isDeleteGamificationLoading = false;
        state.isDeleteGamificationSuccess = true;
        state.deleteGamificationData = action.payload;
      })
      .addCase(deleteGamification.rejected, (state, action) => {
        state.isDeleteGamificationLoading = false;
        state.isDeleteGamificationFailed = true;
        state.deleteGamificationData = null;
        state.deleteGamificationDataErrorContainer = {
          ...state.deleteGamificationDataErrorContainer,
          ...action.payload
        };
      })

      .addCase(saveLikeContent.pending, state => {
        state.isSaveLikeContentLoading = true;
        state.isSaveLikeContentSuccess = false;
        state.isSaveLikeContentFailed = false;
        state.saveLikeContentResponse = null;
        state.saveLikeContentResponseErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(saveLikeContent.fulfilled, (state, action) => {
        state.isSaveLikeContentLoading = false;
        state.isSaveLikeContentSuccess = true;
        state.saveLikeContentResponse = action.payload;
      })
      .addCase(saveLikeContent.rejected, (state, action) => {
        state.isSaveLikeContentLoading = false;
        state.isSaveLikeContentFailed = true;
        state.saveLikeContentResponse = null;
        state.saveLikeContentResponseErrorContainer = {
          ...state.saveLikeContentResponseErrorContainer,
          ...action.payload
        };
      })

      .addCase(deleteLikeContent.pending, state => {
        state.isDeleteLikeContentLoading = true;
        state.isDeleteLikeContentSuccess = false;
        state.isDeleteLikeContentFailed = false;
        state.deleteLikeContentResponse = null;
        state.deleteLikeContentResponseErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(deleteLikeContent.fulfilled, (state, action) => {
        state.isDeleteLikeContentLoading = false;
        state.isDeleteLikeContentSuccess = true;
        state.deleteLikeContentResponse = action.payload;
      })
      .addCase(deleteLikeContent.rejected, (state, action) => {
        state.isDeleteLikeContentLoading = false;
        state.isDeleteLikeContentFailed = true;
        state.deleteLikeContentResponse = null;
        state.deleteLikeContentResponseErrorContainer = {
          ...state.deleteLikeContentResponseErrorContainer,
          ...action.payload
        };
      });
  }
});

export default resourceSlice.reducer;
